<template>
  <div class="inline top-16  max-w-sm px-4">
    <Popover v-slot="{ open }" class="relative">
      <PopoverButton :class="open ? 'text-gray-600' : 'text-gray-900'" class="btn-variant-link flex flex-row">
        <span><slot name="button"> Popover </slot></span>
        <ChevronDownIcon :class="open ? 'text-orange-300' : 'text-orange-400'" class="ml-2 h-5 w-5 transition duration-150 ease-in-out group-hover:text-orange-300/80" aria-hidden="true" />
      </PopoverButton>

      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="translate-y-1 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-1 opacity-0"
      >
        <PopoverPanel class="absolute -left-72 z-10 mt-8 w-screen max-w-sm transform px-4 sm:px-0 lg:max-w-max">
          <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5">
            <div class="relative grid bg-white p-7 lg:grid-cols-4">
              <div class="flex flex-col gap-8">
                <div class="uppercase">
                  Featured
                </div>
                <a v-for="item in featured" :key="item.name" :href="item.href" class="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50">
                  <div class="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12">
                    <div v-html="item.icon" />
                  </div>
                  <div class="ml-4">
                    <p class="text-sm font-medium text-gray-900">
                      {{ item.name }}
                    </p>
                    <p class="text-sm text-gray-500">
                      {{ item.description }}
                    </p>
                  </div>
                </a>
              </div>
              <div class="flex flex-col gap-8">
                <div class="uppercase">
                  Get Involved
                </div>
                <a v-for="item in getInvolved" :key="item.name" :href="item.href" class="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50">
                  <div class="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12">
                    <div v-html="item.icon" />
                  </div>
                  <div class="ml-4">
                    <p class="text-sm font-medium text-gray-900">
                      {{ item.name }}
                    </p>
                    <p class="text-sm text-gray-500">
                      {{ item.description }}
                    </p>
                  </div>
                </a>
              </div>
              <div class="flex flex-col gap-8">
                <div class="uppercase">
                  Resources
                </div>
                <a v-for="item in resources" :key="item.name" :href="item.href" class="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50">
                  <div class="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12">
                    <div v-html="item.icon" />
                  </div>
                  <div class="ml-4">
                    <p class="text-sm font-medium text-gray-900">
                      {{ item.name }}
                    </p>
                    <p class="text-sm text-gray-500">
                      {{ item.description }}
                    </p>
                  </div>
                </a>
              </div>
              <div>
                <tw-card class="bg-gray-900 text-white h-full flex flex-col justify-between" size="lg">
                  <div>
                    <h3>Fundraising made personal</h3>
                    <p class="text-sm text-gray-300">
                      Start, share, and inspire giving for causes close to your heart.
                    </p>
                  </div>
                  <div>
                    <tw-button variant="link" icon-right icon="arrow-right" class="text-white">
                      Learn More
                    </tw-button>
                  </div>
                </tw-card>
              </div>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>
  </div>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import TwCard from '../../components/generic/tw-card.vue'
import TwButton from '../../components/generic/tw-button.vue'
import featured from '../../mixins/home-popover-menu/featured.js'
import getInvolved from '../../mixins/home-popover-menu/getInvolved.js'
import resources from '../../mixins/home-popover-menu/resources.js'


</script>
